import Dropdown from 'bootstrap/js/src/dropdown.js'
import SelectorEngine from 'bootstrap/js/src/dom/selector-engine.js'
import { getNextActiveElement, isVisible, onDOMContentLoaded } from 'bootstrap/js/src/util/index.js'

const SELECTOR_UOE_NAV = '.uoe-nav-primary [data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)'
const SELECTOR_VISIBLE_ITEMS = '.dropdown-menu a[class*=uoe-nav-link-]:not(.disabled):not(:disabled)'
const ARROW_DOWN_KEY = 'ArrowDown'

const refWidth = {
  name: 'edgelRefWidth',
  enabled: true,
  phase: 'beforeWrite',
  requires: ['computeStyles'],
  fn({ state }) {
    state.styles.popper.width = `${state.rects.reference.width}px`
  },
  effect({ state }) {
    state.elements.popper.style.width = `${
      state.elements.reference.offsetWidth
    }px`
  }
}

const WideDropdown = {
  getOrCreateInstance(element) {
    const config = {
      offset: [0, 0],
      popperConfig(defaultBsPopperConfig) {
        const widePopperConfig = {
          modifiers: [],
          ...defaultBsPopperConfig
        }
        widePopperConfig.modifiers.push(refWidth)

        return widePopperConfig
      }
    }

    const reference = element.closest('nav')
    if (reference) {
      config.reference = reference
    }

    const dropdown = Dropdown.getOrCreateInstance(element, config)
    // Check this menu is actually being rendered in the page (ie not hidden by collapse)
    if (!dropdown?._menu) {
      return null
    }

    dropdown.hide()

    // We don't use Bootstrap's classes, so we override the _selectMenuItem to use
    // our version of SELECTOR_VISIBLE_ITEMS
    dropdown._selectMenuItem = ({ key, target }) => {
      const items = SelectorEngine.find(SELECTOR_VISIBLE_ITEMS, dropdown._menu).filter(element => isVisible(element))
      if (!items.length) {
        return
      }

      // if target isn't included in items (e.g. when expanding the dropdown)
      // allow cycling to get the last item in case key equals ARROW_UP_KEY
      getNextActiveElement(items, target, key === ARROW_DOWN_KEY, !items.includes(target)).focus()
    }

    return dropdown
  },
  configureEarly() {
    const _configureEarly = function () {
      for (const dropdown of SelectorEngine.find(this.SELECTOR_UOE_NAV)) {
        WideDropdown.getOrCreateInstance(dropdown)
      }
    }.bind({ SELECTOR_UOE_NAV })

    onDOMContentLoaded(_configureEarly)
  }
}

WideDropdown.configureEarly()

export default WideDropdown
